/*追忆*/
import {getJSON,post} from '@/config/config.js'
import {RECOLLECTION,REMINISCENCE,MOSTSOUGHT,urlpostfix,jsonpostfix} from '@/config/global.js'
export function getzyJsondata(){
  return getJSON(`${jsonpostfix}allWzJSON/${RECOLLECTION}/${RECOLLECTION}.json`)
}
export function getzsJsondata(){
  return getJSON(`${jsonpostfix}allWzJSON/${REMINISCENCE}/${REMINISCENCE}.json`)
}
export function getzxJsondata(){
  return getJSON(`${jsonpostfix}allWzJSON/${MOSTSOUGHT}/${MOSTSOUGHT}.json`)
}
export function getzyAjaxdata(data){
  return post(`${urlpostfix}api/basic/getBasicNew`,data);
}
export function gethotareaJsondata(){
  return getJSON(`${jsonpostfix}allQyJSON/Hotarea.json`)
}







// WEBPACK FOOTER //
// ./src/api/Remembrance.js